import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getAccountList(state) {
    return state.data
  },
}

export const mutations = {
  SET_ACCOUNT_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_ACCOUNT_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_ACCOUNT_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_ACCOUNT_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingAccountList({ commit }, params) {
    commit('SET_ACCOUNT_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/admin/list/',
        payload: { ...params },
      })
      commit('SET_ACCOUNT_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_ACCOUNT_LIST_RECEIVED_FAILED', error)
    }
  },
  resetAccountList({ commit }) {
    commit('RESET_ACCOUNT_LIST')
  },
  async deleteAccountById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/admin/delete/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async exportMemberSettingCsv({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/export_setting/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
